const initial_state = {
  // modal
  modal_cancel_confirmation: {
    is_open: false,
    is_back_active: false,
    is_change_tab: false,
  },
  // important
  description: "",
  loading_item: "",
  loading_status: false,
  status_toolbox: 0,
  draw_toolbox_status: false,
  name_toolbox: "",
  mode_toolbox: "", //features_distance || features_area || features_elevation || features_radius
  mode_draw: "draw_line_string", //draw_point || draw_line_string || draw_polygon || simple_select
  draw_status_toolbox: false,
  geojson_draw: { type: "FeatureCollection", features: [] },
  source_tab: 0, // 0 = bikin || 1 = pake layer
  selected_poi_types: {
    tipe_1: [],
    tipe_2: [],
    tipe_3: [],
  },
  poi_inside_polygons: {}, // Objek yang memuat ID polygon serta daftar ID feature POI yang berada di dalam area polygon tersebut.
  point_inside_elevation_line: {}, // Objek yang memuat ID LineString serta daftar ID feature point yang berada di garis tersebut.
  features_routing_obj: { //object yang memuat ID routing serta daftar ID feature point yang menjadi titik awal dan akhir untuk routing tersebut.
    order: [],
    data: {},
  },
  all_poi_features: [], // semua poi yang udah diget masuk sini
  fields_poi_inside_polygon: [], // fields poi yang diget
  progress_get_data_poi: 0, // persentase loading ketika get poi
  is_loading_get_data_poi: false, // lagi aktif loading atau enggak
  poi_source: "mapid", // "mapid" kalo ambil dari data mapid, "layer" kalo ambil data layer milik user
  layer_ids_poi: [], // berlaku kalo pilih poi_source-nya "layer", ini list geo_layer_id buat kebutuhan get data layernya user
  // toolbox analysis
  start_time: null,
  // cursor
  cursor_mode: "",
  // fields basic for map
  fields_radius: [],
  fields_area: [],
  fields_isochrone: [],
  fields_elevation: [],
  fields_routing: [],
  //features basic for map
  features_distance: [],
  features_distance_label: [],
  features_area: [],
  features_elevation: [],
  features_radius: [],
  features_isochrone: [],
  // visibile veatures
  visible_distance: [],
  visible_elevation: [],
  visible_radius: [],
  visible_area: [],
  visible_isochrone: [],
  visible_routing: [],
  //features for label
  features_distance_center: [],
  features_area_center: [],
  features_elevation_center: [],
  // features for polygon
  features_isochrone_polygon: [],
  //elevation data
  elevation_chart_array: [],
  //uuid for selected item
  uuid_distance: [],
  uuid_area: [],
  uuid_elevation: [],
  uuid_radius: [],
  uuid_isochrone: [],
  uuid_routing: [],
  //default value for radius
  default_radius_km: 1,
  default_radius_m: 1000,
  //default value for isochrone
  isochrone_profile: "car",
  contour_type: "minutes",
  contours_minutes: 10,
  contours_meters: 1000,
  //history data point yang udah diget, supaya yang udah diget ga perlu diget lagi
  poi_fetched_layer_ids_per_isochrone: {},
  poi_fetched_layer_ids_per_radius: {},
  poi_fetched_layer_ids_per_area: {},
  //input toolbox grid
  toolbox_grid_object: {
    layer_point_ids: [],
    layer_polygon_ids: [],
    grid_mode: "square", //square, hex
    grid_size_mode: "count", //count, width
    grid_counts: 200,
    grid_width_meters: 5,
    bbox_mode: "polygon", //point, polygon
    unit_density: "m_square", //m_square, km_square
    total_square_meters: 0,
    total_poi_initial: 0,
    item_name: "", //bebas isi
    min_grid_value: 0,
    max_grid_value: 1,
  },
  //variable untuk routing
  routing_active_uuid: "",
  routing_profile: "car",
  //variable for grid heatmap toolbox
  layer_list_point_obj: {},
  layer_list_polygon_obj: {},
  // layer_list_point_raw: [],
  // layer_list_point_filtered: [],
  // layer_list_polygon_raw: [],
  // layer_list_polygon_filtered: [],

  //output grid result
  select_mode: "", //point || polygon
  current_grid_group: 0,
  total_grid_group: 1,
  features_grid_raw: [],
  features_grid: [],
};

export default function toolboxReducer(state = initial_state, action) {
  switch (action.type) {
    case "status_toolbox":
      return {
        ...state,
        status_toolbox: state.status_toolbox + 1,
      };

    case "set_loading_toolbox":
      return {
        ...state,
        loading_item: action.payload,
        loading_status: true,
      };

    case "clear_loading_toolbox":
      return {
        ...state,
        loading_item: "",
        loading_status: false,
      };

    case "set_value_toolbox":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case "push_value_toolbox":
      return {
        ...state,
        [action.payload.key]: [
          ...state[action.payload.key],
          ...action.payload.value,
        ],
      };

    case "push_value_toolbox_single":
      return {
        ...state,
        [action.payload.key]: [
          ...state[action.payload.key],
          action.payload.value,
        ],
      };

    case "push_value_toolbox_multiple":
      return {
        ...state,
        [action.payload.key]: [
          ...state[action.payload.key],
          ...action.payload.value,
        ],
      };

    case "change_radius":
      return {
        ...state,
        features_radius: change_radius(state.features_radius, action.payload),
      };

    default:
      return state;
  }
}

const change_radius = (list, body) => {
  const { uuid, key, value } = body;
  const index = list.findIndex((item) => item.properties.uuid === uuid);
  list[index].properties[key] = value;
  if (key === "radius_m") {
    const radius_km = value / 1000;
    list[index].properties["radius_km"] = radius_km;
  } else if (key === "radius_km") {
    const radius_m = value * 1000;
    list[index].properties["radius_m"] = radius_m;
  }
  return list;
};
